<div class="container-fluid">
  <!-- 🧩 Top Row - Patient Details -->
  <div class="row g-2 align-items-center justify-content-around">
    <!-- Card Number -->
    <div class="col-md-3 mb-2">
      <label>Card Number</label>
      <p-dropdown
        id="card"
        name="card"
        [options]="cardList"
        [(ngModel)]="patient.card_id"
        optionLabel="label"
        optionValue="value"
        placeholder="Select a Card"
      ></p-dropdown>
    </div>

    <!-- Salutation + Name -->
    <div class="col-md-5 mb-2">
      <div class="input-group">
        <select
          name="salutation"
          id="salutation"
          class="form-select"
          style="max-width: 100px; background-color: #fff8e6;"
          [(ngModel)]="patient.salutation"
        >
          <option value="">Select</option>
          <option value="Mr.">Mr.</option>
          <option value="Ms.">Ms.</option>
          <option value="Mrs.">Mrs.</option>
          <option value="Shri.">Shri.</option>
          <option value="Smt.">Smt.</option>
          <option value="Ku.">Ku.</option>
          <option value="Dr.">Dr.</option>
          <option value="Prof.">Prof.</option>
          <option value="Er.">Er.</option>
          <option value="CA.">CA.</option>
          <option value="Adv.">Adv.</option>
        </select>

        <input
          type="text"
          name="full_name"
          class="form-control"
          placeholder="Patient Name"
          style="background-color: #fff8e6;"
          [(ngModel)]="patient.full_name"
        />
      </div>
    </div>

    <!-- Age -->
    <div class="col-md-2 mb-2">
      <div class="row align-items-center">
        <div class="col-6 text-end">
          <h5>Age</h5>
        </div>
        <div class="col-6">
          <input
            type="number"
            id="age"
            name="age"
            class="form-control"
            style="background-color: #e4f3ff;"
            [(ngModel)]="patient.age"
          />
        </div>
      </div>
    </div>
  </div>

  <hr />

  <!-- 🧩 Middle Section - Voice Dictation -->
  <div class="row g-3">
    <!-- Left Column -->
    <div class="col-md-6">
      <!-- Summary -->
      
      

      <div class="voice-controls d-flex gap-2 mt-2">
        <label>Summary</label>

        <div class="voice-controls d-flex gap-2 sdp ">
        <button
          type="button"
          class="circle-btn start"
          (click)="startDictation('summary')"
          [disabled]="isRecording && activeField !== 'summary'"
        >
          <i class="pi pi-microphone"></i>
        </button>

        <button
          type="button"
          class="circle-btn listening"
          *ngIf="isRecording && activeField === 'summary'"
        >
          <i class="pi pi-wave-pulse"></i>
        </button>

        <button
          type="button"
          class="circle-btn stop"
          (click)="stopRecording()"
          [disabled]="!isRecording || activeField !== 'summary'"
        >
          <i class="pi pi-stop"></i>
        </button>
        </div>
      </div>
      <textarea
        id="summary"
        name="summary"
        class="form-control"
        rows="3"
        style="background-color: #fff8e6;"
        [(ngModel)]="prescription.summary"
        [disabled]="isRecording && activeField !== 'summary'"
      ></textarea>

      <!-- Chief Complaints -->

      <div class="voice-controls d-flex gap-2 mt-3">
         <label >Chief Complaints</label>

          <div class="voice-controls d-flex gap-2  sdp">
        <button
          type="button"
          class="circle-btn start"
          (click)="startDictation('chief_complaints')"
          [disabled]="isRecording && activeField !== 'chief_complaints'"
        >
          <i class="pi pi-microphone"></i>
        </button>

        <button
          type="button"
          class="circle-btn listening"
          *ngIf="isRecording && activeField === 'chief_complaints'"
        >
          <i class="pi pi-wave-pulse"></i>
        </button>

        <button
          type="button"
          class="circle-btn stop"
          (click)="stopRecording()"
          [disabled]="!isRecording || activeField !== 'chief_complaints'"
        >
          <i class="pi pi-stop"></i>
        </button>
        </div>
      </div>
     
      <textarea
        id="chief_complaints"
        name="chief_complaints"
        class="form-control"
        rows="3"
        [(ngModel)]="prescription.chief_complaints"
        [disabled]="isRecording && activeField !== 'chief_complaints'"
      ></textarea>

      
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <!-- Medicines -->


      <div class="voice-controls d-flex gap-2 mt-2">
         <label>Medicines</label>
          <div class="voice-controls d-flex gap-2 sdp ">
        <button
          type="button"
          class="circle-btn start"
          (click)="startDictation('medicines')"
          [disabled]="isRecording && activeField !== 'medicines'"
        >
          <i class="pi pi-microphone"></i>
        </button>

        <button
          type="button"
          class="circle-btn listening"
          *ngIf="isRecording && activeField === 'medicines'"
        >
          <i class="pi pi-wave-pulse"></i>
        </button>

        <button
          type="button"
          class="circle-btn stop"
          (click)="stopRecording()"
          [disabled]="!isRecording || activeField !== 'medicines'"
        >
          <i class="pi pi-stop"></i>
        </button>
        </div>
      </div>
     
      <textarea
        name="medicines"
        class="form-control"
        rows="3"
        style="background-color: rgba(23, 207, 81, 0.3);"
        [(ngModel)]="prescription.medicines"
        [disabled]="isRecording && activeField !== 'medicines'"
      ></textarea>

      

      <!-- Diagnosis -->
       
      <div class="voice-controls d-flex gap-2 mt-3">
         <label >Diagnosis</label>
          <div class="voice-controls d-flex gap-2 sdp ">
        <button
          type="button"
          class="circle-btn start"
          (click)="startDictation('diagnosis')"
          [disabled]="isRecording && activeField !== 'diagnosis'"
        >
          <i class="pi pi-microphone"></i>
        </button>

        <button
          type="button"
          class="circle-btn listening"
          *ngIf="isRecording && activeField === 'diagnosis'"
        >
          <i class="pi pi-wave-pulse"></i>
        </button>

        <button
          type="button"
          class="circle-btn stop"
          (click)="stopRecording()"
          [disabled]="!isRecording || activeField !== 'diagnosis'"
        >
          <i class="pi pi-stop"></i>
        </button>
      </div>
      </div>
   
     
      <textarea
        id="diagnosis"
        name="diagnosis"
        class="form-control"
        rows="3"
        [(ngModel)]="prescription.diagnosis"
        [disabled]="isRecording && activeField !== 'diagnosis'"
      ></textarea>
 </div>
  </div>

  <hr />

  <!-- 🧩 Accordion Sections (Unchanged functionality) -->
  <p-accordion
    [multiple]="false"
    [activeIndex]="[]"
    styleClass="mt-2"
    (onOpen)="accordionIndex = $event.index"
    (onClose)="accordionIndex = null"
  >
    <!-- ✅ First Accordion Row -->
    <div class="row">
      <div
        [ngClass]="
          accordionIndex === 0
            ? 'col-md-10'
            : accordionIndex === 1
            ? 'col-md-2'
            : 'col-md-8'
        "
      >
        <p-accordionTab
          class="accordion-custom"
          header="Past History | Menstrual History | Obstetric History"
          (onOpen)="accordionIndex = 0"
          (onClose)="accordionIndex = null"
        >
          <div class="row g-2">
            <div class="col-md-4">
              <label>Past History of any</label>
              <textarea
                id="past_history"
                name="past_history"
                class="form-control"
                rows="2"
                [(ngModel)]="prescription.past_history"
              ></textarea>
            </div>
            <div class="col-md-4">
              <label>Menstrual History</label>
              <textarea
                id="menstrual_history"
                name="menstrual_history"
                class="form-control"
                rows="2"
                [(ngModel)]="prescription.menstrual_history"
              ></textarea>
            </div>
            <div class="col-md-4">
              <label>Obstetric History</label>
              <textarea
                id="obstetric_history"
                name="obstetric_history"
                class="form-control"
                rows="2"
                [(ngModel)]="prescription.obstetric_history"
              ></textarea>
            </div>
          </div>
        </p-accordionTab>
      </div>

      <div
        [ngClass]="
          accordionIndex === 1
            ? 'col-md-10'
            : accordionIndex === 0
            ? 'col-md-2'
            : 'col-md-4'
        "
      >
        <p-accordionTab class="accordion-custom" header="Personal Details">
          <div class="row g-2 mt-2">
            <div class="col-md-6">
              <label>Under</label>
              <select
                name="under_dr"
                class="form-select"
                style="background-color: rgba(23, 207, 81, 0.3);"
                [(ngModel)]="patient.under_dr"
              >
                <option value="">Dr. Subodh Bhade</option>
                <option value="">Dr 2</option>
              </select>
            </div>
            <div class="col-md-6">
              <label>Contact Number</label>
              <input
                name="family_history"
                class="form-control"
                [(ngModel)]="patient.contact_number"
              />
            </div>
            <div class="col-md-6">
              <label>Referred By Dr</label>
              <input
                name="personal_history"
                class="form-control"
                [(ngModel)]="patient.referred_by_dr"
              />
            </div>
            <div class="col-md-6">
              <label>Referred By</label>
              <select
                name="referred_by"
                class="form-select"
                style="background-color: rgba(23, 207, 81, 0.3);"
                [(ngModel)]="patient.referred_by"
              >
                <option value="Parents">Parents</option>
                <option value="Siblings">Siblings</option>
                <option value="Relatives">Relatives</option>
                <option value="Friends">Friends</option>
              </select>
            </div>
          </div>
        </p-accordionTab>
      </div>
    </div>

    <!-- ✅ Second Accordion Row -->
    <div class="row mt-2">
      <div
        [ngClass]="
          accordionIndex === 2
            ? 'col-md-10'
            : accordionIndex === 3
            ? 'col-md-2'
            : 'col-md-8'
        "
      >
        <p-accordionTab class="accordion-custom" header="R/S | CVS | CNS | P/A">
          <div class="row g-2 mt-2">
            <div class="col-md-6">
              <label>R/S</label>
              <textarea
                id="respiratory_system"
                name="respiratory_system"
                class="form-control"
                rows="3"
                [(ngModel)]="prescription.respiratory_system"
              ></textarea>
            </div>
            <div class="col-md-6">
              <label>CVS</label>
              <textarea
                id="cardiovascular_system"
                name="cardiovascular_system"
                class="form-control"
                rows="3"
                [(ngModel)]="prescription.cardiovascular_system"
              ></textarea>
            </div>
            <div class="col-md-6">
              <label>CNS</label>
              <textarea
                id="central_nervous_system"
                name="central_nervous_system"
                class="form-control"
                rows="3"
                [(ngModel)]="prescription.central_nervous_system"
              ></textarea>
            </div>
            <div class="col-md-6">
              <label>P/A</label>
              <textarea
                id="per_abdomen"
                name="per_abdomen"
                class="form-control"
                rows="3"
                [(ngModel)]="prescription.per_abdomen"
              ></textarea>
            </div>
          </div>
        </p-accordionTab>
      </div>

      <div
        [ngClass]="
          accordionIndex === 3
            ? 'col-md-10'
            : accordionIndex === 2
            ? 'col-md-2'
            : 'col-md-4'
        "
      >
        <p-accordionTab class="accordion-custom" header="Family History">
          <div class="row g-2 mt-2">
            <div class="col-md-12">
              <label>FH Mother</label>
              <input
                name="family_history_mother"
                type="text"
                class="form-control"
                style="background-color: #fff8e6;"
                [(ngModel)]="prescription.family_history.mother"
              />
            </div>
            <div class="col-md-12">
              <label>FH Father</label>
              <input
                name="family_history_father"
                type="text"
                class="form-control"
                style="background-color: #fff8e6;"
                [(ngModel)]="prescription.family_history.father"
              />
            </div>
            <div class="col-md-12 mt-2">
              <label>FH Other</label>
              <input
                name="family_history_other"
                type="text"
                class="form-control"
                style="background-color: #fff8e6;"
                [(ngModel)]="prescription.family_history.other"
              />
            </div>
          </div>
        </p-accordionTab>
      </div>
    </div>
  </p-accordion>

  <hr />

  <!-- 🧾 Bottom Section -->
  <div class="row g-2">
    <div class="col-md-2">
      <p-floatLabel>
        <input
          id="card_dues"
          name="card_dues"
          type="number"
          pInputText
          class="form-control"
          [(ngModel)]="prescription.card_dues"
          readonly
        />
        <label for="card_dues">CARD DUES</label>
      </p-floatLabel>
    </div>

    <div class="col-md-2">
      <p-floatLabel>
        <input
          id="visit_fees"
          name="visit_fees"
          type="number"
          pInputText
          class="form-control"
          [(ngModel)]="prescription.visit_fees"
          (ngModelChange)="prescription.personal_dues = calculatePersonalDues(filteredRecords, prescription)"
        />
        <label for="visit_fees">Fees for this visit</label>
      </p-floatLabel>
    </div>

    <div class="col-md-2">
      <p-floatLabel>
        <input
          id="received_cash"
          name="received_cash"
          type="number"
          pInputText
          class="form-control"
          [(ngModel)]="prescription.received_cash"
          (ngModelChange)="prescription.personal_dues = calculatePersonalDues(filteredRecords, prescription)"
        />
        <label for="received_cash">Cash</label>
      </p-floatLabel>
    </div>

    <div class="col-md-2">
      <p-floatLabel>
        <input
          id="received_online"
          name="received_online"
          type="number"
          pInputText
          class="form-control"
          [(ngModel)]="prescription.received_online"
          (ngModelChange)="prescription.personal_dues = calculatePersonalDues(filteredRecords, prescription)"
        />
        <label for="received_online">Online / UPI</label>
      </p-floatLabel>
    </div>

    <div class="col-md-2">
      <p-floatLabel>
        <input
          id="personal_dues"
          name="personal_dues"
          type="number"
          pInputText
          class="form-control"
          [(ngModel)]="prescription.personal_dues"
          readonly
        />
        <label for="personal_dues">PERSONAL DUES</label>
      </p-floatLabel>
    </div>
  </div>

  <hr />

  <!-- 🧩 Action Buttons -->
  <div class="row g-2 mt-3 align-items-center mb-3">
    <div class="col-md-2">
      <button
        pButton
        type="button"
        class="btn btn-success w-100"
        (click)="addVoicetest()"
      >
        Save Changes
      </button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-success w-100" (click)="onPrintReceipt()">
        Print Receipt
      </button>
    </div>
  </div>
</div>
